import { defineStore } from 'pinia'
import { getToken, setToken } from '@/utils/auth'
import { updateToken } from '@/api/index'

// export const useStore = defineStore("main", {
export const useStore = defineStore('user', {
  // first style
  state: () => {
    return {
      // 所有这些属性的类型都将被自动推断出来
      token: getToken(),
      update_token: getToken(),
      route_path: null
    }
  },
  // second style
  // state: () => ({
  //   counter: 0,
  //   name: 'Eduardo',
  //   isAdmin: true
  // }),
  // getters: {
  //   setToken: (state, token) => state.token = token,
  //   setUpdateToken: (state, updatetoken) => state.update_token = updatetoken,
  //   setIsUpload: (state, isupload) => state.is_upload = isupload,
  //   setIsVerify: (state, isverify) => state.is_verify = isverify,
  //   setIsOverdue: (state, isoverdue) => state.is_overdue = isoverdue,
  //   setRoutePath: (state, path) => state.route_path = path
  // },
  actions: {
    async updateToken () {
      const result = await updateToken()
      const updatedToken = result.data
      setToken(updatedToken)
      this.$patch(state => {
        state.update_token = updateToken
      })
    },
    changeToken (token) {
      this.$patch(state => {
        state.token = token
      })
    },
    setToken (token) {
      this.$patch(state => (state.token = token))
    },
    setUpdateToken (updatedToken) {
      this.$patch(state => (state.update_token = updatedToken))
    },
    setRoutePath (path) {
      this.$patch(state => (state.route_path = path))
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/pinia.js